export default __webpack_public_path__ + "static/media/projects_repd.6b1b99d6.geojson";